import { Fragment, React, useState, useEffect } from "react";

import PermissionTable from "../Permission/PermissionTable";
import LayoutHOC from "../LayoutHOC";
import GroupsTable from "../Groups/CompanyGroupsTable";
import PermissionLevel from "../Permission/CompanyPermissionLevel";
import AddPermission from "../Permission/AddCompanyPermission.js";
import { useFetchPermissionTableDataQuery } from "../../utils/company/companypermissions";
import useRequireAuth from "../../utils/useRequireAuth";
import CustomerListTable from "../customer/CustomerListTable";
import PermissionHeader from "../Permission/CompanyPermissionHeader";
import { Dialog, Tooltip } from "@mui/material";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { orgGroupAddUpdateMember, useOrgGroupAddUpdateMemberMutation } from "../../utils/users/Organizations";
import { EDIT_USER_LIST_BASED_ON_ID, GET_GROUP_DATA } from "../../utils/constants";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import { ReactComponent as PencilIcon } from "../../assets/images/pencilIcon.svg";
import { useFetchUserDataTableDataQuery } from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { showLoader, hideLoader } from "../../utils/loaderSlice";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import {
  useFetchGroupTableDataNodeQuery,
  useFetchPermissionTableDataNodeQuery,
  useLazyFetchUsersInGroupTableDataNodeQuery,
} from "../../utils/users/permissions";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { getCompanyId, getOrganizationId, getUserToken } from "../../utils/utilityFunctions/localServices";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as CrossIcon } from "../../assets/images/CrossIconCreateGroup.svg";
import CreateGroupDrawer from "./Drawers/CreateGroupDrawer";
import AddPermissionForm from "./AddPermissionForm";

const CustomerManagePermission = () => {
  const [group, setGroup] = useState(null);
  const [permission, setPermission] = useState(null);
  const [permissionTablePagination, setPermissionTablePagination] = useState("");
  const [initialFilter, setInitialFilter] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [openPermission, setOpenPermission] = useState(false);
  const [grantPrmission, setGrantPrmission] = useState(false);
  const [locationFlag, setLocationFlag] = useState(true);
  const { token } = useRequireAuth();
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;

  const { data: permissionTableALL, refetch: refetchPermissionData } = useFetchPermissionTableDataQuery({
    pagination: `${permissionTablePagination}`,
    token: token,
  });

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => {
    console.warn(companyId, "companyIdcompanyIdcompanyId");
    fetchPersonInTable({ token: userdata?.token, data: data, companyId: companyId?.company_id });
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (permissionTableALL && permissionTableALL.data) {
      DataLoad();
    }
  }, [permissionTableALL, permissionTablePagination, refetchPermissionData]);

  const DataLoad = () => {
    const { data, ...restData } = permissionTableALL.data;
    setPermission(data);
    setInitialFilter(restData);
  };

  const handleActionEdit = (data) => {
    setIsPopupOpen(data);
  };

  const handleNavigate = (data, items, header, taskid) => {
    if (items[header?.key]?.field_name === "group_name") {
      setGroup(items);
      setPermission(null);
    } else if (items[header?.key]?.field_name === "permission") {
      setPermission(items);
      setGroup(null);
    }
  };

  const handleCreateGroupClick = () => {
    setOpenPermission(false);
    setGroup(null);
    setPermission(null);
    setIsPopupOpen(true);
  };

  const handleCreatePermissionClick = () => {
    setOpenPermission(true);
    setGroup(null);
  };

  const handleGrantPermissionClick = () => {
    setGrantPrmission(true);
  };

  const manageCompanyPermissionNav = [
    { href: "#CreatePermission", label: "Create Permission", onClick: handleCreatePermissionClick },
    { href: "#CreateGroup", label: "Create Group", onClick: handleCreateGroupClick },
    { href: "#GrantPermission", label: "Grant Permission", onClick: handleGrantPermissionClick },
    { href: "#Check User", label: "Check User", onClick: () => setCheckUser(true) },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    window.location.hash = tabId;
  };

  const closeGroupDrawer = () => {
    setIsGroupDrawerOpen(false);
    setGroupDrawerData(null);
  };

  const [formData, setFormData] = useState({
    owner: 0,
    email: "",
    // group_id: groupid?.group_name?.id,
  });

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [role, setRole] = useState("");
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [activePerson, setActivePerson] = useState({});
  const [groupData, setGroupData] = useState({});
  const userdata = useRequireAuth();
  const [checkUser, setCheckUser] = useState(false);
  const [quiFilter, setQuiFilter] = useState({ external: 0, status: 1 });
  const [isGroupActive, setIsGroupActive] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isGroupDrawerOpen, setIsGroupDrawerOpen] = useState(false);
  const [permissionData, setPermissionData] = useState([]);
  const [isAddPermissionOpen, setIsAddPermissionOpen] = useState(false);
  const [createPermission, setCreatePermission] = useState(false);
  const [isGrantPermissionOpen, setIsGrantPermissionOpen] = useState(false);
  const [clickedGroupId, setClickedGroupId] = useState(null);
  const [usersTableData, setUsersTableData] = useState([]);
  const [permissionFormData, setPermissionFormData] = useState(null);
  const [groupDrawerData, setGroupDrawerData] = useState(null);

  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isFetching: userDataLoading,
  } = useFetchUserDataTableDataQuery({
    pagination: `?company_id=${companyId}&per_page=20&page=1&search=&sort_direction=initial&sort_by=null`,
    quiFilter: quiFilter,
    token: token,
  });

  useEffect(() => {
    refetchCustomerData();
  }, []);

  const [fetchUsersInGroup, { data: UsersInGroupData }] = useLazyFetchUsersInGroupTableDataNodeQuery();

  useEffect(() => {
    if (clickedGroupId) {
      fetchUsersInGroup({
        token: getUserToken(),
        params: { groupId: clickedGroupId.id, companyId: getCompanyId(), orgId: getOrganizationId() },
      });
    }
  }, [clickedGroupId]);
  useEffect(() => {
    if (UsersInGroupData) {
      setUsersTableData(UsersInGroupData.data);
    }
  }, [UsersInGroupData]);

  const {
    data: PermissionTableData,
    error,
    isLoading,
  } = useFetchPermissionTableDataNodeQuery({
    token: getUserToken(),
    params: {
      companyId: getCompanyId(),
    },
  });

  useEffect(() => {
    if (PermissionTableData) {
      setPermissionData(PermissionTableData?.data);
    }
  }, [PermissionTableData]);

  const { data: GroupTableData } = useFetchGroupTableDataNodeQuery({
    token: getUserToken(),
    params: {
      companyId: getCompanyId(),
    },
  });

  useEffect(() => {
    if (GroupTableData) {
      console.log("insideiftest");

      setGroupData(GroupTableData?.data);
    }
  }, [GroupTableData]);

  useEffect(() => {
    if (userDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [userDataLoading]);

  const handleSaveData = (person) => {
    setActivePerson(person);
  };

  const initialFormData = {
    owner: "",
    email: "",
  };

  const [orgGroupAddUpdateMember, { orgGroupMemberDropLoad, orgGroupMemberDroperror }] =
    useOrgGroupAddUpdateMemberMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const groupData = {
        ...formData,
        // id: editId,
        group: selectedGroup,
      };

      const response = await orgGroupAddUpdateMember({
        token: userdata?.token,
        data: groupData,
      });

      if (response?.success && response?.data?.success) {
        // refetchData();
        setFormData(initialFormData);
        dispatch(pushAlert({ visible: true, message: "Successfully Record Insert", type: "success" }));
        // closePopup();
      } else {
        dispatch(pushAlert({ visible: true, message: response?.error?.data?.error, type: "danger" }));
        // refetchData();
        // closePopup();
      }
    } catch (err) {
      dispatch(pushAlert({ visible: true, message: "Something went wrong", type: "danger" }));
      console.error("Error while adding/updating:", err);
    }
  };

  const tableDetail = {
    tableidclass: "usermodelmember",
  };

  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: item,
    }));
  };

  const handleCheckUserClose = () => {
    setCheckUser(false);
  };

  const closeCheckUserOutside = useClickOutside(() => {
    setCheckUser(false);
  });

  const handleEditCheckUser = () => {};

  const handleCancel = () => {
    setCheckUser(false);
  };

  const closePermissionForm = () => {
    setIsAddPermissionOpen(false);
  };

  const handleEditClick = () => {
    setCheckUser(false);
    handleGrantPermissionClick();
    const href = "#GrantPermission";
    setActiveTab(href);
    window.history.pushState(null, "", href);
  };

  const handleGroupActive = (item) => {
    console.log("itemforstate", item);

    if (item === "Group") {
      setIsGroupActive(true);
    } else if (item === "Permission") {
      setIsGroupActive(false);
    } else {
      setOpenDrawer(item);
    }
  };

  const SideBarItems = [
    { title: "Group" },
    { title: "Permission" },
    { title: "Grant Permission" },
    { title: "Check User" },
  ];
  console.log("clickedGroupID", clickedGroupId);

  return (
    <div className="flex gap-5 px-4 h-screen ">
      <div className="w-1/7 h-full">
        <div className="h-full flex flex-col ">
          <div className="text-[#1d4469] font-semibold text-[16px] mb-1">Manage Permission</div>
          <div className="bg-white shadow-md rounded-md w-[100%] mt-2 min-h-0 grow ">
            <ul className="text-gray-600 rounded-md p-3">
              {SideBarItems.map((item, index) => (
                <li
                  className={`hover:bg-cyan-900 hover:text-white cursor-pointer rounded mb-1 px-4 py-2 text-[13px]
                 ${item.title === "Group" && isGroupActive ? "bg-cyan-900 text-white" : ""}
                 ${item.title === "Permission" && !isGroupActive ? "bg-cyan-900 text-white" : ""}
                `}
                  onClick={() => handleGroupActive(item.title)}
                >
                  {item?.title}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="min-w-0 grow ">
        {isGroupActive && !clickedGroupId ? (
          <>
            <ReactTableComponent
              body={groupData}
              headers={[
                {
                  accessor_key: "group_name",
                  label: "Group Name",
                  callingFunction: (item) => {
                    console.log("clicked");

                    setClickedGroupId(item);
                  },
                },
                {
                  accessor_key: "permission_description",
                  label: "Descripton",
                },
                {
                  accessor_key: "permission",
                  label: "Permisson Level",
                  callingFunction: () => {},
                },
              ]}
              actionField={
                <div className="flex items-center h-full">
                  <div className="flex items-center ml-1 cursor-pointer">
                    <ToolTipComponent text="Add Group" style={{ color: "#1D4469" }}>
                      <span onClick={() => setIsGroupDrawerOpen(true)}>
                        <PlusIcon />
                      </span>
                    </ToolTipComponent>
                  </div>
                </div>
              }
              actionColumn={(item) => {
                return (
                  <div
                    onClick={() => {
                      setIsGroupDrawerOpen(true);
                      setGroupDrawerData(item);
                    }}
                  >
                    <PencilIcon className="delete-button" />
                  </div>
                );
              }}
            />
          </>
        ) : isGroupActive && clickedGroupId ? (
          <>
            <ReactTableComponent
              body={usersTableData}
              headers={[
                { accessor_key: "userName", label: "Name" },
                { accessor_key: "isOwner", label: "Access" },
              ]}
              subChildDisplay={
                <div className="flex items-center p-1 gap-2 border rounded-xl bg-white">
                  <p>{clickedGroupId.group_name}</p>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setClickedGroupId(null);
                    }}
                  >
                    <CrossIcon />
                  </div>
                </div>
              }
            />
          </>
        ) : !isGroupActive && !isAddPermissionOpen ? (
          <>
            <ReactTableComponent
              body={permissionData}
              headers={[
                {
                  accessor_key: "permissionLevel",
                  label: "Name",
                  callingFunction: () => {},
                },
                {
                  accessor_key: "description",
                  label: "Descripton",
                },
              ]}
              actionField={
                <div className="flex items-center h-full">
                  <div className="flex items-center ml-1 cursor-pointer">
                    <ToolTipComponent text="Add Permission" style={{ color: "#1D4469" }}>
                      <span
                        onClick={() => {
                          setIsAddPermissionOpen(true);
                        }}
                      >
                        <PlusIcon />
                      </span>
                    </ToolTipComponent>
                  </div>
                </div>
              }
              actionColumn={(item) => {
                return (
                  <div>
                    <PencilIcon className="delete-button" />
                  </div>
                );
              }}
            />
          </>
        ) : (
          <>
            <AddPermissionForm close={closePermissionForm} data={setPermissionFormData} />
          </>
        )}
      </div>
      {isGroupDrawerOpen && (
        <CreateGroupDrawer
          isOpen={isGroupDrawerOpen}
          onClose={closeGroupDrawer}
          permissionData={permissionData}
          data={groupDrawerData}
        />
      )}

      {openDrawer === "Grant Permission" && <></>}
    </div>
    // <div className="p-4 pt-0 mt-0">
    //   <div className="w-full mt-2">
    //     {group?.group_name && !openPermission ? (

    //       <Fragment>
    //         <GroupsTable
    //           handleNavigates={handleNavigate}
    //           TableNav={TableNav}
    //           groupid={group}
    //           setGroup={setGroup}
    //           companyId={companyId}
    //         />
    //       </Fragment>
    //     ) : permission?.permission || openPermission ? (
    //       <Fragment>
    //         <PermissionLevel
    //           handleNavigate={handleNavigate}
    //           TableNav={TableNav}
    //           ButtonEvent={() => {
    //             setPermission(null);
    //             setOpenPermission(false);
    //           }}
    //           PermissionLevelId={permission}
    //           companyid={companyId}
    //         />
    //       </Fragment>
    //     ) : (
    //       <PermissionTable
    //         handleNavigate={handleNavigate}
    //         TableNav={TableNav}
    //         isPopupOpen={isPopupOpen}
    //         setIsPopupOpen={setIsPopupOpen}
    //         locationFlag={locationFlag}
    //       />
    //     )}
    //   </div>
    //   {grantPrmission && (
    //     <Dialog open={grantPrmission} onClose={() => setGrantPrmission(false)}>
    //       <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-gray-900 bg-opacity-50">
    //         <div className="relative mt-18 bg-white  font-popns drop-shadow-lg  rounded-md w-[520px] overflow-hidden no-scrollbar">
    //           <div className="mx-6 flex items-center justify-between pt-4 md:pt-3  border-b border-BECBD3 rounded-t">
    //             <h3 className="text-base text-434852 font-500">Grant Permission</h3>
    //             <button
    //               onClick={() => setGrantPrmission(false)}
    //               type="button"
    //               className="text-454545  hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
    //               data-modal-hide="assets-modal"
    //             >
    //               <CloseModalImg className="w-3 h-3" />
    //               <span className="sr-only">Close modal</span>
    //             </button>
    //           </div>

    //           <form className={`w-full lg:max-h-[70vh]  pt-2`} onSubmit={handleSubmit}>
    //             <div className="grid px-6 py-1">
    //               <div>
    //                 <label htmlFor="email" className="block text-sm pb-1">
    //                   <span className=" text-434852 ">Name</span>
    //                   <span className=" text-red-500"> *</span>
    //                 </label>
    //                 <OwnerDropDown
    //                   tableidclass={tableDetail.tableidclass}
    //                   fetchPersonInTable={fetchPersonData}
    //                   DropData={personTableData}
    //                   handleInsert={handleInsert}
    //                   owner={formData?.email}
    //                   fieldname={"email"}
    //                 />
    //               </div>
    //             </div>
    //             <div className="basis-5/5  px-6 pt-2">
    //               <label className="text-14 text-434852 font-400">Group</label>
    //               <select
    //                 id={`group`}
    //                 name="group"
    //                 onClick={getUserInfo}
    //                 onChange={handleGroupChange}
    //                 className={`form-select border border-BFBFBF text-383838 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 mb-1 py-1`}
    //               >
    //                 {groupData.map((item) => (
    //                   <option key={item.id} value={item.id}>
    //                     {item.group_name}
    //                   </option>
    //                 ))}
    //               </select>
    //             </div>
    //             <div className="basis-5/5 mb-3 px-6 pt-2">
    //               <label htmlFor="Designation" className="block pb-1 text-sm text-434852">
    //                 Access <span className=" text-red-500"> *</span>
    //               </label>
    //               <select
    //                 id={`owner`}
    //                 name="owner"
    //                 onChange={handleFieldChange}
    //                 className={`form-select border border-BFBFBF text-383838 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 mb-1 py-1`}
    //               >
    //                 <option value="0" selected={formData?.owner === 0}>
    //                   Contributor
    //                 </option>
    //                 <option value="1" selected={formData?.owner === 1}>
    //                   Owner
    //                 </option>
    //               </select>
    //             </div>

    //             <div className="sticky bottom-0 pb-2 pr-4 flex justify-end  text-md w-full rounded-none z-[9998]">
    //               <div className="px-2 mr-1">
    //                 <button
    //                   onClick={() => setGrantPrmission(false)}
    //                   type="button"
    //                   className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
    //                 >
    //                   CANCEL
    //                 </button>
    //                 <button
    //                   type="submit"
    //                   className="w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
    //                 >
    //                   SAVE
    //                 </button>
    //               </div>
    //             </div>
    //           </form>
    //         </div>
    //       </div>
    //     </Dialog>
    //   )}

    //   {checkUser && (
    //     <Dialog
    //       open={checkUser}
    //       // onClose={() => setCheckUser(false)}
    //       // ref={closeCheckUserOutside}
    //     >
    //       <form
    //       // onSubmit={getUserInfo}
    //       >
    //         <div className="p-2 px-4 w-[510px] pb-4">
    //           <div className="flex justify-between items-center border-b border-BECBD3">
    //             <h5 className="text-16 text-434852 font-500">Check User</h5>
    //             <button
    //               type="button"
    //               className="text-454545 hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
    //               data-modal-hide="assets-modal"
    //               onClick={handleCheckUserClose}
    //             >
    //               <CloseModalImg className="w-3 h-3" />
    //             </button>
    //           </div>
    //           <div className="mt-2">
    //             <div>
    //               <label htmlFor="email" className="block text-sm pb-1">
    //                 <span className=" text-434852 ">Name</span>
    //                 <span className=" text-red-500"> *</span>
    //               </label>
    //               <OwnerDropDown
    //                 tableidclass={tableDetail.tableidclass}
    //                 fetchPersonInTable={fetchPersonData}
    //                 DropData={personTableData}
    //                 handleInsert={handleInsert}
    //                 owner={formData?.id}
    //                 fieldname={"email"}
    //                 handleSaveData={handleSaveData}
    //               />
    //             </div>
    //           </div>
    //           <div className="mt-2 flex justify-end gap-3">
    //             <button
    //               className="bg-F4F4F4 text-535252 text-14 font-500 px-4 py-2 rounded"
    //               type="button"
    //               onClick={handleCancel}
    //             >
    //               Cancel
    //             </button>
    //             <button
    //               className="bg-1D4469 text-white text-14 font-500 px-4 py-2 rounded"
    //               type="submit"
    //               onClick={getUserInfo}
    //             >
    //               Check Now
    //             </button>
    //           </div>
    //           <div className="w-full mt-4">
    //             <label className="w-full flex text-16 text-434852 font-600 py-2">Group Name</label>
    //             <div className="flex justify-between">
    //               <button className="bg-EBEBEB p-2 px-5  rounded">
    //                 {selectedGroupName ? selectedGroupName : "N/A"}
    //               </button>
    //               <Tooltip
    //                 placement="top"
    //                 title="Edit"
    //                 PopperProps={{
    //                   modifiers: [
    //                     {
    //                       name: "offset",
    //                       options: {
    //                         offset: [0, -5],
    //                       },
    //                     },
    //                   ],
    //                 }}
    //                 componentsProps={{
    //                   tooltip: {
    //                     sx: {
    //                       backgroundColor: "black",
    //                       color: "white",
    //                       boxShadow: "none",
    //                       height: "23px",
    //                       display: "flex",
    //                       alignItems: "center",
    //                     },
    //                   },
    //                 }}
    //               >
    //                 <button
    //                   className="bg-[#E9EFF5] flex items-center justify-center rounded-full p-2 w-8 h-8"
    //                   onClick={handleEditClick}
    //                 >
    //                   <PencilIcon className="w-4 h-4 text-gray-700" />
    //                 </button>
    //               </Tooltip>
    //             </div>
    //           </div>
    //           <div className="w-full mt-4">
    //             <label className="w-full flex text-16 text-434852 font-600 py-2">Access Type</label>
    //             <button className="bg-EBEBEB p-2 px-5  rounded">{role ? role : "N/A"}</button>
    //           </div>
    //         </div>
    //       </form>
    //     </Dialog>
    //   )}
    // </div>
  );
};

export default LayoutHOC(CustomerManagePermission);
